// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_0KH3A","clearfix":"reset_clearfix_CzZ7Q"};